import React,{useState, useRef} from "react";
import useClickOutside from "./useClickOutside";

const MultiSelect = ({ value , id , name , checkbox , setCheckBox}) => {
    const[toggleDropDown, setToogleDropDown]=useState(false)
   const ref =useRef(null)
   useClickOutside(ref,()=> setToogleDropDown(false))
    const handleChange= (e )=>{ 
  
        setCheckBox({
        ...checkbox,[e.target.value]: !checkbox[e.target.value]
        })
     
    }

    return (
        <div ref={ref} className="
         flex 
         flex-col
        justify-center
         cursor-pointer
        w-full  ">
            <div id="dropdownSearchButton" onClick={()=>setToogleDropDown(!toggleDropDown)} placeholder="select to open DropDwon" data-dropdown-toggle="dropdownSearch" className="bg-clip-padding bg-white block border border-gray-300 border-solid ease-in-out flex focus:bg-white focus:border-blue-600 focus:outline-none focus:text-gray-700 h-12 font-normal items-center m-0 px-6 py-1.5 rounded text-base text-gray-700 transition w-full" >{value?.filter((v)=> checkbox[v[id]] )?.map((a)=> a[name])?.join(" , ") || "Select Control Names" }</div>
            {toggleDropDown && <div id="dropdownSearch" 
            className="relative
             mt-23 
              bg-white dark:bg-gray-700 
              rounded 
               shadow-xl
                 w-full " data-popper-reference-hidden="" data-popper-escaped="" data-popper-placement="bottom" >
                <ul 
                className="
                 bg-white 
                  relative
                   w-full 
                    px-3
                     pb-3 
                     text-sm
                      text-gray-700
                       dark:text-gray-200"
                        aria-labelledby="dropdownSearchButton">
                    {value?.map((val) => {
                        return ( 
                            <li key={val[id]} className="
                            flex 
                            w-full 
                            relative 
                            items-center 
                            justify-between"
                             >
                                <div  className="
                                flex
                                 w-full 
                                 items-center 
                                 p-2 
                                 rounded 
                                 hover:bg-gray-100 
                                 dark:hover:bg-gray-600">
                                    <input id={val[id]} checked={checkbox[val[id]]} onChange={handleChange} name={val[name]} value={val[id]} type="checkbox" 
                                     className="
                                     w-4 
                                     h-4 
                                     text-blue-600
                                      bg-gray-100 
                                      rounded 
                                      border-gray-300 
                                      focus:ring-blue-500 
                                      dark:focus:ring-blue-600 
                                      dark:ring-offset-gray-700 
                                      focus:ring-2 
                                      dark:bg-gray-600 
                                      dark:border-gray-500" 
                                      />
                                    <label htmlFor="checkbox-item-11"
                                     className="
                                     ml-2 
                                     px-5
                                      w-full 
                                      text-sm
                                       font-medium
                                        text-gray-900
                                         rounded dark:text-gray-300
                                         "
                                         >{val[name]}</label>
                                </div>
                            </li>
                        )
                    })
                    }
                </ul>
            </div>}
        </div>
    )
}

export default MultiSelect;